/**
 * A global namespace for aria-describedby.
 */
const ariaDescribedBy = "aria-describedby";
export default ariaDescribedBy;
